import React, { Component } from "react";
import InfoCard from "./InfoCard";

class LeftIntro extends Component {
  // Function to parse and render text with formatting
  parseText = (text) => {
    if (typeof text !== "string") return text;

    // Split by formatting markers while preserving them
    const parts = text.split(/(\*\*.*?\*\*|__.*?__|_.*?_|\*.*?\*)/g);

    return parts.map((part, index) => {
      // Bold: **text**
      if (part.startsWith("**") && part.endsWith("**")) {
        return <strong key={index}>{part.slice(2, -2)}</strong>;
      }
      // Underline: __text__
      if (part.startsWith("__") && part.endsWith("__")) {
        return <u key={index}>{part.slice(2, -2)}</u>;
      }
      // Italic: *text* or _text_
      if (
        (part.startsWith("*") && part.endsWith("*")) ||
        (part.startsWith("_") && part.endsWith("_"))
      ) {
        return <em key={index}>{part.slice(1, -1)}</em>;
      }
      return part;
    });
  };

  renderContent = (item, index) => {
    // If item is an object with bullets property, render as list
    if (typeof item === "object" && item.bullets) {
      return (
        <ul key={index}>
          {item.bullets.map((bullet, bulletIndex) => (
            <li key={bulletIndex}>{this.parseText(bullet)}</li>
          ))}
        </ul>
      );
    }
    // If item is an object with header property, render as heading
    if (typeof item === "object" && item.header) {
      const { level = 3, text } = item.header;
      const HeaderTag = `h${Math.min(Math.max(level, 1), 6)}`; // Ensure level is between 1-6

      return (
        <HeaderTag key={index} className="m-0">
          {this.parseText(text)}
        </HeaderTag>
      );
    }
    // Otherwise render as paragraph
    return item ? <p key={index}>{this.parseText(item)}</p> : null;
  };

  render() {
    const { title, chip, content = [], img, titleLevel = 2 } = this.props;

    // Create dynamic title tag based on titleLevel prop
    const TitleTag = `h${Math.min(Math.max(titleLevel, 1), 6)}`;

    return (
      <div className="container">
        <div className="row middle-sm">
          <div className="col-md-5" style={{ paddingRight: 24 }}>
            {chip && <span className="chip m-0">{chip}</span>}
            {title && <TitleTag className="m-0">{title}</TitleTag>}
            {Array.isArray(content) && content.map(this.renderContent)}
          </div>
          <div className="col-sm-7" style={{ paddingRight: 24 }}>
            {img && (
              <img
                src={img}
                className="img-shadow"
                width="100%"
                alt="content visual"
              />
            )}
          </div>
        </div>
      </div>
    );
  }
}

export default LeftIntro;
